import React, { Dispatch, SetStateAction } from 'react'
import { CreditApplication, CreditApplicationDocument, CreditDocument } from '_gql'

import { useMakeTestId } from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'
import PopSheet, { PopSheetControl } from '@divvy-web/skylab.popsheet'
import Spinner from '@divvy-web/skylab.spinner'

import UploaderTileList from '@sputnik/components/UploaderTileList/UploaderTileList'

import { documentUploadPageWrapperCss } from './DocumentSelectionPopSheetStyles'

interface DocumentSelectionPopSheetProps {
  creditApp: CreditApplication
  remainingDocs: CreditDocument[]
  setRemainingDocs: Dispatch<SetStateAction<CreditDocument[]>>
  setShowUploader: (value: boolean) => void
  setUploaderReady: (value: boolean) => void
  showUploader: boolean
  uploaderReady: boolean
  refetch: () => void
}
const DocumentSelectionPopSheet = ({
  creditApp,
  remainingDocs,
  setRemainingDocs,
  setShowUploader,
  setUploaderReady,
  showUploader,
  uploaderReady,
  refetch,
}: DocumentSelectionPopSheetProps) => {
  const showSpinner = showUploader && !uploaderReady
  const requiredDocuments = creditApp?.requiredDocs
  const makeTestId = useMakeTestId('DocumentSelectionPopSheet')

  if (showSpinner) return <Spinner fullPage />

  return (
    <PopSheetControl
      isShowing={showUploader}
      onScrimClick={() => setShowUploader(false)}
    >
      <PopSheet
        actions={
          <BasicButton
            dataTestId={makeTestId('close')}
            icon='close'
            name='Close'
            type={BASIC_BUTTON_TYPE_OUTLINED}
            onClick={() => {
              setShowUploader(false)
              setUploaderReady(false)
              refetch()
            }}
          />
        }
        // @ts-expect-error - need to figure out why this skylab component is not registering this emotion prop
        css={documentUploadPageWrapperCss}
        title={
          <FormattedMessage
            defaultMessage='Documents'
            id='sputnik.DocumentSelectionPopSheet__vBlT6y'
          />
        }
      >
        <div className='fs-unmask'>
          <div className='page-area'>
            <div className='page-content'>
              <UploaderTileList
                creditApp={creditApp}
                remainingDocs={remainingDocs}
                requiredDocuments={requiredDocuments as CreditApplicationDocument[]}
                setRemainingDocs={setRemainingDocs}
              />
            </div>
          </div>
        </div>
      </PopSheet>
    </PopSheetControl>
  )
}

export default DocumentSelectionPopSheet
